import react from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography,Icon,FormHelperText } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CommonQuillEditor from "common/editor";
function BottomSection({
    formData,
    setFormData,
    errors,
    setErrors,
    bottomSectionOpen,
    setBottomSectionOpen,
}) {
    return <Accordion
            expanded={bottomSectionOpen}
            onChange={() => setBottomSectionOpen(!bottomSectionOpen)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panelbottomsection-content"
              id="panelbottomsection-header"
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="h4" fontWeight="semibold" style={{ color: "#2E2E3A" }}>
                  Bottom Section
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container direction="row" spacing={3}>
                <Grid item xs={12} md={12}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    style={{ fontSize: "14px" }}
                    name="bottomSectionDescription"
                  >
                    Bottom Description
                  </Typography>
                  <Box className="remove-quill-mb">
                    <CommonQuillEditor
                      allowHeading={false}
                      value={formData.bottomSection?.description || ""}
                      onChange={(value) => {
                        setFormData((prev) => ({
                          ...prev,
                          bottomSection: {
                            ...prev.bottomSection,
                            description: value,
                          },
                        }));
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          bottomSectionDescription: "",
                        }));
                      }}
                    />
                    {Boolean(errors?.bottomSectionDescription) && (
                      <FormHelperText error style={{ marginTop: "-20px" }}>
                        {errors?.bottomSectionDescription}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
}

export default BottomSection